var _circle, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNew9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 126,
    viewBox: "0 0 109 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 54.238,
    cy: 54.238,
    r: 54.238,
    fill: "#D9D9D9",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.1892 45.8133C57.7104 46.8675 55.9008 47.4876 53.9463 47.4876C48.9528 47.4876 44.9047 43.4395 44.9047 38.446C44.9047 33.4524 48.9528 29.4043 53.9463 29.4043C57.1832 29.4043 60.0228 31.1052 61.6201 33.662M39.738 76.1294H46.4812C47.3605 76.1294 48.2343 76.2341 49.0866 76.4433L56.2116 78.1747C57.7576 78.5514 59.3682 78.588 60.9303 78.2846L68.8082 76.7519C70.8892 76.3465 72.8036 75.35 74.3039 73.8906L79.8775 68.4687C81.4693 66.923 81.4693 64.4147 79.8775 62.8664C78.4445 61.4723 76.1752 61.3154 74.5539 62.4976L68.058 67.2368C67.1278 67.9169 65.9958 68.283 64.8316 68.283H58.5589L62.5516 68.2829C64.802 68.2829 66.625 66.5096 66.625 64.3204V63.5279C66.625 61.7102 65.3532 60.1252 63.541 59.6858L57.3785 58.1871C56.3756 57.9439 55.3486 57.821 54.3161 57.821C51.8237 57.821 47.3121 59.8846 47.3121 59.8846L39.738 63.0519M75.9047 41.0293C75.9047 46.0229 71.8566 50.071 66.863 50.071C61.8694 50.071 57.8213 46.0229 57.8213 41.0293C57.8213 36.0357 61.8694 31.9876 66.863 31.9876C71.8566 31.9876 75.9047 36.0357 75.9047 41.0293ZM29.4047 61.9543L29.4047 76.9376C29.4047 78.3844 29.4047 79.1078 29.6862 79.6604C29.9339 80.1465 30.3291 80.5417 30.8152 80.7894C31.3678 81.071 32.0912 81.071 33.538 81.071H35.6047C37.0515 81.071 37.7749 81.071 38.3275 80.7894C38.8136 80.5417 39.2088 80.1465 39.4564 79.6604C39.738 79.1078 39.738 78.3844 39.738 76.9376V61.9543C39.738 60.5075 39.738 59.7841 39.4564 59.2315C39.2088 58.7454 38.8136 58.3502 38.3275 58.1025C37.7749 57.821 37.0515 57.821 35.6047 57.821L33.538 57.821C32.0912 57.821 31.3678 57.821 30.8152 58.1025C30.3291 58.3502 29.9339 58.7454 29.6862 59.2315C29.4047 59.7841 29.4047 60.5075 29.4047 61.9543Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_12318_410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0116 121.476L54.238 120.476L93.4644 121.476V122.425L54.238 123.425L15.0116 122.425V121.476Z",
    fill: "url(#paint0_linear_12318_410)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_12318_410",
    x: 13.0116,
    y: 118.476,
    width: 82.4528,
    height: 6.94922,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_12318_410"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12318_410",
    x1: 15.0116,
    y1: 121.951,
    x2: 93.4644,
    y2: 121.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0528846,
    stopColor: "#06378F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#85D4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932692,
    stopColor: "#06378F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew9);
export default __webpack_public_path__ + "static/media/new-9.3e558fb238291f9d6b6a6f7326513371.svg";
export { ForwardRef as ReactComponent };